
import React, {useState, useEffect, useCallback, useRef} from 'react';
import isEqual from 'lodash/isEqual';
import { useSelector } from 'react-redux';
import HelpIcon from './HelpIcon';
import config from '../../config/config';
import chtypes from '../../helpers/chouseenumerated.js';
import './CompanyDirectorSelect.css';


const CompanyDirectorSelect = ({
    value = null,
    onChange = () => {},
    company_number, field,
    name = 'selcompanydircxtor',
    label = '',
    helptext,
    }) => {
    const [directors, setDirectors ] = useState([])
    const [companynumber, setCompanyNumber] = useState(null)
    const [newDirector, setNewDirector] = useState('')
    const [director, setDirector] = useState(value)
    const [loaded, setLoaded] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error,setError] = useState('')

    const token = useSelector((state) => state.auth.token);

    const prevDirectors = useRef();
    console.log(field)
    const fetchDirectors = useCallback(async () => {
        try {
            const url = `${config.API_BASE_URL}/companies/getcompanyofficers/${company_number}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if(response.ok) {

                const cdir = await response.json();
                if(cdir.status) {
                    let dirs = [];
                    const now = new Date()
                    const prev3years = `${now.getFullYear()}-01-01`
                    let id = 1;
                    for(const director of cdir.data.items) {
                        if(!(director.resigned_on??null) || (director.resigned_on > prev3years) ) {
                            dirs.push({
                                name: formatName(director.name),
                                officer_role: chtypes.officer_role[director.officer_role],
                                id: director.person_number??id,
                                companyhouseadded: true
                            })
                        }
                        id++;
                    }
                    setDirectors(dirs)
                    setCompanyNumber(company_number)

                }else
                    setError(`Error fetching Directors Details from Companies house`)
            }else
                setError(`Error fetching Directors Details from Companies house`)
        }catch(err) {
            setError(`Error fetching Directors Details from Companies house (${err.toString})`)
        }
    },[company_number]);


    useEffect(()=>{
        async function getDirectors() {
            setLoading(true)
            setLoaded(false)
            setError("")
            try {
                await fetchDirectors()
            }catch(error) {
                setError(`Error fetching Directors Details from Companies house ${error.toString()}`)
            }
            setLoading(false)
            setLoaded(true)
        }
        if(company_number && companynumber !== company_number )
            getDirectors()
    },[loaded,company_number,companynumber, setCompanyNumber, setLoaded, fetchDirectors])



    const formatName = (namein) => {
        let  nparts = namein.split(',')
        nparts = nparts.map(item => item.trim())
        nparts = (nparts.reverse()).join(' ').toUpperCase()
        return nparts
    }

    // Update form state whenever local directors array changes
    useEffect(() => {
        if (!isEqual(prevDirectors.current, director)) {
          prevDirectors.current = director;
          onChange(director);
        }
      }, [director, onChange]);

      useEffect(() => {
        // Only update local state if value changed from outside (not just from our own onChange)
        if (!isEqual(value, prevDirectors.current)) {
            prevDirectors.current = value;
          setDirector(value || "");
        }
      }, [value]);

    const addDirector = () => {
        if((newDirector??'') === '') {
            alert("You Must Enter a Name for the New Director!");
            return;
        }
        setDirectors((current) => {
            const newDirs = [...current, {
                name: newDirector,
                officer_role: '',
                id: `added_${current.length+1}`,
            }]
            return newDirs
        })
    }


    const onSelectDirector = (e) => {
        setDirector(e.target.value)
    }

    if(directors.length === 0)return null;

    return (
        <fieldset className='fieldset'>
            <legend className='legend'>
                Select Main A Director Contact
                <HelpIcon helptext={helptext} />
            </legend>
            {loading && <h5>Loading Director Data. Please wait...</h5>}
            {error > "" && <span style={{color: 'red'}} >{error}</span >}
            {loaded &&
            <div className='itemcontainer' >
                <select name={name} id={name} value={director} onChange={onSelectDirector} >
                    <option value="">Please Select A Director</option>
                {directors.map((director,index) => (
                  <option value={director.name} key={`${name}_dir_opt_${index}`} >{director.name}{`${director.ocupation > "" ? ' - ' + director.ocupation :''}`}</option>
                ))}
                </select>
                <div className='alignlabel' >Or Enter Director Name <input type='text' id='new_director' value={newDirector} onChange={(e) => setNewDirector(e.target.value)} />&nbsp;
                <button type='button' onClick={() => addDirector()} >Add Director</button></div>
            </div>
            }
        </fieldset>

    )

}

export default CompanyDirectorSelect;
